<template>

    <div class="sticky-header-next-sec ec-breadcrumb section-space-mb">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row ec_breadcrumb_inner">
                        <div class="col-md-6 col-sm-12"><h2 class="ec-breadcrumb-title">المنتجات المفضلة</h2></div>
                        <div class="col-md-6 col-sm-12"><!-- ec-breadcrumb-list start -->
                            <ul class="ec-breadcrumb-list">
                                <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                <li class="ec-breadcrumb-item active">المنتجات المفضلة</li>
                            </ul><!-- ec-breadcrumb-list end --></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ec Shop page -->
    <section class="ec-page-content section-space-p">

        <div class="container">
            <div class="row">
                <div class="ec-shop-rightside order-md-first margin-b-30">
                    <!-- Shop content Start -->
                    <div class="shop-pro-content">

                        <div class="shop-pro-inner" v-if="items?.data?.length > 0">
                            <div class="row">

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-6 "
                                     v-for="product in items?.data" :key="product.id">
                                    <div class="ec-product-sbtn border rounded-3">
                                        <div class="ec-product-image">

                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                                class="ec-image">

                                                <img class="pic-1"
                                                     :src="product.image ?? '/images/spices-jar.jpeg'"
                                                     alt=""/>
                                                <img class="pic-2"
                                                     :src="product.image ?? '/images/spices-jar.jpeg'"
                                                     alt=""/>
                                            </router-link>

                                            <!--                                            <span class="ec-product-sale-label">hot</span>-->
                                            <!--                                            <span class="ec-product-discount-label">-33%</span>-->
                                        </div>
                                        <div class="ec-product-body">
                                            <!--                                            <ul class="ec-rating">-->
                                            <!--                                                <li class="ecicon eci-star fill"></li>-->
                                            <!--                                                <li class="ecicon eci-star fill"></li>-->
                                            <!--                                                <li class="ecicon eci-star fill"></li>-->
                                            <!--                                                <li class="ecicon eci-star fill"></li>-->
                                            <!--                                                <li class="ecicon eci-star"></li>-->
                                            <!--                                            </ul>-->
                                            <h3 class="ec-title">

                                                <router-link
                                                    :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                    {{ product?.name }}
                                                </router-link>

                                            </h3>
                                            <div class="ec-price">
                                                {{ product?.price_tax }} {{ $t('SAR') }}
                                            </div>
                                            <div class="ec-product-button-group">

                                                <favoriteIcon
                                                    :item="product"
                                                    @update:item="product.favorite = $event.favorite"
                                                    :theme="'ec-product-like-icon'">

                                                </favoriteIcon>

                                                <!--                                                <a class="ec-add-to-cart" href="#">ADD TO CART</a>-->

                                                <CartButton :product="product"  v-if="product?.id != null" :type="'ec-link-btn'"></CartButton>

                                                <!--                                                <a class="ec-product-compare-icon" href="#"><i class="fi fi-rr-arrows-repeat"></i></a>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Ec Pagination Start -->
                        <div class="ec-pro-pagination" v-if="items?.data?.length > 0">
                            <span> </span>

                            <Bootstrap5Pagination
                                class="m-2"
                                :data="items"
                                :limit="2"
                                :show-disabled="false"
                                :size="'default'"
                                :align="'center'"
                                @pagination-change-page="getResults"
                            />
                        </div>
                        <div class="alert alert-info text-center" v-else>
                            لا يوجد منتجات مفضلة.
                        </div>



                        <!-- Ec Pagination End -->
                    </div>
                    <!--Shop content End -->
                </div>
            </div>
        </div>
    </section>
    <!-- End Shop page -->

</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import Utility from "../../utility";

import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import CartButton from "../cart_item/CartButton.vue";
import favoriteIcon from "./favorite-icon.vue";

export default {
    props: ['main'],
    components: {
        favoriteIcon,
        CartButton,
        Bootstrap5Pagination
    },
    watch: {
        'q': { // Auto search
            handler: function (newValue) {
                console.log('---handler');
                this.getResults(1);
            },
            deep: true
        }
    },
    data() {
        return {
            getResultsOnCreate: true,
            max_price: 1000,
            debounceTimer: null,
            items: [],
            q_price: {
                from: null,
                to: null
            },
            q: {
                order: null,
                price: {
                    from: null,
                    to: null
                },
                category_ids: [],
                section_ids: [],
                // occasion_ids : [],
                quantities: {
                    from: null,
                    to: null
                },
                ...this.$route.query,
            },
            form_options: {},
        }
    },
    async created() {
        console.log('---created');
        // console.log(this.$route?.query);
        // console.log(this.$route?.query?.length);
        //
        // const numberOfQueryKeys = Object.keys(this.$route?.query || {}).length;
        // console.log(numberOfQueryKeys);

        this.removeArrayQueries(this.q);

        if (this.getResultsOnCreate) {
            await this.getResults(this.$route?.query?.page ?? 1);
        }

        await this.themeJs();
    },
    methods: {
        removeArrayQueries(dataObject) {
            // const that = this;
            // Function to remove array-based query parameters from the 'q' data object
            console.log('removeArrayQueries');
            for (const key in dataObject) {
                const matches = key.match(/(\w+)\[(\d*)\]/);

                if (
                    matches !== null
                ) {

                    const new_key = matches[1];
                    // console.log(new_key);
                    console.log(typeof dataObject[key]);

                    // push new value  to dataObject[new_key] or create new if not exists and push
                    if (Array.isArray(dataObject[new_key])) {
                        dataObject[new_key].push(dataObject[key]);
                        this.getResultsOnCreate = false;
                    } else {
                        dataObject[new_key] = [dataObject[key]];
                        this.getResultsOnCreate = false;
                    }
                    delete dataObject[key];
                }
            }
            return dataObject;
        },
        setName(val) {
            this.q.name = val;
        },
        themeJs() {

            (function ($) {
                "use strict";

                /*=====================
                02. Shop Page Grid Setting Js
                ==========================*/
                $(".grid-option li").on("click", function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                $(".grid-option .grid-btn").on("click", function () {
                    $(".product-list-section").removeClass("list-style");
                });
                $(".grid-option .list-btn").on("click", function () {
                    $(".product-list-section").addClass("list-style");
                });
                $('.three-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.grid-btn').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.five-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("list-style").addClass("row-cols-xxl-5 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                var contentwidth = $(window).width();
                if (contentwidth < "1199") {
                    $(".grid-options ul .grid-btn").addClass("active");
                }
                if (contentwidth < "1399") {
                    $(".grid-options ul .three-grid").addClass("active");
                }
            })(jQuery);

            /**=====================
             Filter Sidebar js
             ==========================**/
            $(".filter-button").click(function () {
                console.log('---- filter-button');
                $(".bg-overlay, .left-box").addClass("show");
            });
            $(".back-button, .bg-overlay").click(function () {
                $(".bg-overlay, .left-box").removeClass("show");
            });

            $(document).ready(function () {
                $(".sort-by-button").click(function () {
                    $(".top-filter-menu").toggleClass("show");
                });
            });
        },
        onPriceInput() {
            // Clear the previous timer if exists
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            // Set up a new timer to call the handler after 500ms (adjust the time as needed)
            this.debounceTimer = setTimeout(() => {

                // Perform actions or update the filter based on the provided values
                // For example, you can emit an event to notify the parent component of the changes.
                this.q.price = {
                    'from': this.q_price.from,
                    'to': this.q_price.to,
                };
            }, 500); // Adjust the delay time (in milliseconds) as needed
        },
        async getResults(page) {
            console.log('getResults <---');

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-light fa-filter-list'});


            const _params = {
                ...this.q,
                page: page,
            };

            let form_params = Utility.convertModelToFormData(_params);

            await axios.get('products/favorite', {params: form_params}).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                this.max_price = response.data?.max_price ?? 1000;

                // this.$router.replace({
                //     name: "products.index",
                //     query: form_params , params: { lang : this.$i18n.locale }
                // });
                console.log('replace <---');

            }, response => {
                toast.dismiss(id);
            });

        },
    }
}
</script>
